module.exports = __webpack_public_path__ + "static/img/龙头主升.8225e0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/龙头主升.png
// module id = wLco
// module chunks = 1